import { adhd_asrs } from './adhd_asrs';
import { ham_anxiety } from './ham_anxiety';

export const allSurveys = {
    adhd: adhd_asrs,
    anxiety: ham_anxiety
};